import {Modal} from 'bootstrap';
import {Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, OnDestroy} from '@angular/core';
import {IsFilterOnService} from '../../../../Services/is-filter-on.service';
import {TypeaheadBase} from '../../../common/typeahead/typeahead-base';

@Component({
  selector: 'app-account-select',
  templateUrl: './account-select.component.html',
  styleUrls: ['./account-select.component.css'],
  standalone: false
})
export class AccountSelectComponent extends TypeaheadBase implements OnInit, OnDestroy {
  @ViewChild('closeButton') closeButton: ElementRef;
  @Input() vm: any;
  @Output() selectAccountEmit = new EventEmitter<string>();
  @Output() updateAccountEmit = new EventEmitter<string>();
  @Output() testAccountEmit = new EventEmitter<string>();
  public accounts: any;
  accountTypeaheadSearch = (text$: any) => this.typeaheadSearch(text$, () => this.vm?.accountName, 10);

  constructor(public isFiltered: IsFilterOnService) {
    super();
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    const modalEl = this.closeButton?.nativeElement?.closest('.modal');
    if (modalEl) {
      const modal = Modal.getInstance(modalEl);
      if (modal) {
        modal.hide();
      }
    }
  }

  updateAccount() {
    this.updateAccountEmit.emit();
  }

  selectAccount(accountId) {
    // $('#accountSelect').modal('hide');
    this.selectAccountEmit.emit(accountId);
  }

  testAccount($event = null) {
    this.testAccountEmit.emit($event);
  }

  checkFiltered(): boolean {
    const filteredValue = this.isFiltered.isFiltered(this.vm);
    this.vm.filtered = filteredValue;
    return filteredValue;
  }

  // Return all accounts matching current filters across the full values list (not just the current page)
  getFilteredAccounts(): any[] {
    const list: any[] = Array.isArray(this.vm?.account) ? this.vm.account : [];
    const filter = this.vm?.accountFilter || {};

    const search = String(filter.search_string ?? '').toLowerCase().trim();
    const typeName = String(filter.type_name ?? '').toLowerCase().trim();

    return list.filter(acc => {
      if (!acc) {
        return false;
      }
      // Apply type filter if set
      if (typeName) {
        const accType = String(acc.type_name ?? '').toLowerCase();
        if (accType !== typeName) {
          return false;
        }
      }
      // Apply search across number and name
      if (search) {
        const num = String(acc.number ?? '').toLowerCase();
        const name = String(acc.name ?? '').toLowerCase();
        const combo = (num + ' ' + name).trim();
        if (!num.includes(search) && !name.includes(search) && !combo.includes(search)) {
          return false;
        }
      }
      return true;
    });
  }
}
